import { getDocumentCategories, getDocumentStatuse, getDocumentTypes } from "../../pnp-docs/pnp-docs.actions";

/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpSettingsComplianceReport = {
    /* @ngInject */
    controller: function ($ngRedux, $rootScope, DocumentManager) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ policies }) => ({
                pnpDocument: policies.pnpDocument
            }), {
                getDocumentCategories,
                getDocumentTypes,
                getDocumentStatuse
            })(this);

            this.getDocumentTypes('dms');
            this.getDocumentCategories();
            this.getDocumentStatuse();
        }

        this.onDownloadButton = ({ item }) => {
            DocumentManager.downloadFile(item.path);
        };

        this.onReset = (event) => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'pnpSettingsComplianceReportFilterForm');
        };

        this.$onDestroy = () => {  
            this.unsubscribe();        
        }
    },
    template: `
        <pnp-settings-compliance-report-grid
            on-download="$ctrl.onDownloadButton($event)"
            on-reset="$ctrl.onReset($event)">
        </pnp-settings-compliance-report-grid>
    `
};
